module.exports = __webpack_public_path__ + "media/images/categoryIcons/lgbtq_icon-edf3947ebacefe77633f5d55b7e3bbdb.svg";